import { render, staticRenderFns } from "./MultipleFiles.vue?vue&type=template&id=70123d7f&"
import script from "./MultipleFiles.vue?vue&type=script&lang=js&"
export * from "./MultipleFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VFileInput,VImg,VMessages})
